export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  duration: string;
  image: string;
  date: string;
  tags: string[];
  listenCount: number;
}

export const articles: Article[] = [
  {
    id: 'art-001',
    title: '深夜图书馆：翻书声与笔尖书写',
    excerpt: '在安静的深夜图书馆中，感受翻书的沙沙声与钢笔在纸上划过的细腻触感，让你的思绪沉淀。',
    content: `<p>欢迎来到深夜图书馆。这里没有喧嚣，只有纸张与墨水的低语。</p>
<p>闭上眼睛，想象你正坐在一间古老的图书馆里。四周是高耸的书架，空气中弥漫着旧书特有的木质香气。窗外是深沉的夜色，只有桌上的一盏台灯投下温暖的光晕。</p>
<p>你听到的第一种声音，是翻书的声音——不是匆忙的翻阅，而是缓慢的、充满仪式感的翻页。每一页纸在指尖滑过，发出细腻的沙沙声，像是时间在轻声诉说。</p>
<p>接着是钢笔在纸上的书写声。笔尖触及纸面的那一刻，墨水缓缓渗透，留下一道道优雅的痕迹。有时是流畅的长句，有时是停顿的思考，那轻微的刮擦声带着一种奇妙的满足感。</p>
<p>偶尔，你会听到远处钟摆的滴答声，或是椅子轻轻挪动的声音。这些细微的声响交织在一起，构成了一幅属于夜晚的宁静画卷。</p>
<p>在这个空间里，时间仿佛放慢了脚步。焦虑和压力一点一点地从你的身体里流走，取而代之的是一种深度的平静。</p>
<p><strong>适合场景：</strong>学习陪伴、深度专注、睡前放松</p>
<p><strong>音频时长：</strong>45分钟</p>`,
    category: 'whisper',
    author: '安眠图书馆',
    duration: '45分钟',
    image: 'https://readdy.ai/api/search-image?query=Quiet%20old%20library%20at%20night%20with%20warm%20desk%20lamp%20glow%2C%20tall%20wooden%20bookshelves%2C%20open%20book%20on%20wooden%20desk%2C%20fountain%20pen%2C%20soft%20atmospheric%20lighting%2C%20minimalist%20cozy%20aesthetic%2C%20cream%20and%20deep%20brown%20tones&width=1200&height=800&seq=article-library-01&orientation=landscape',
    date: '2026-07-28',
    tags: ['翻书声', '书写声', '图书馆', '深夜', '白噪音'],
    listenCount: 28600,
  },
  {
    id: 'art-002',
    title: '雨夜窗边：淅沥雨声与远方雷鸣',
    excerpt: '躺在一个温暖的小屋里，听窗外雨滴敲打玻璃的声音，远处的闷雷为你编织最美的摇篮曲。',
    content: `<p>这是属于雨夜的独家记忆。</p>
<p>想象你正蜷缩在一张柔软的床上，被子厚实而温暖。窗外，雨正下着——不大不小，刚刚好。雨滴敲打在玻璃窗上，发出清脆而有节奏的声音，像是大自然在为你演奏一首催眠曲。</p>
<p>远处偶尔传来低沉的雷鸣，不是那种令人害怕的炸雷，而是闷闷的、远远的，像是天空在轻声呢喃。雷声过后，雨声似乎变得更加清晰，每一滴雨水都在讲述着自己的故事。</p>
<p>房间里很暗，只有窗外透进来的微弱光线。你可以听到屋檐下雨水滴落的声音，啪嗒、啪嗒，节奏不紧不慢。偶尔有风吹过，带动树叶沙沙作响，为这场雨夜交响乐增添了更多层次。</p>
<p>在这样的声音包裹中，你会感到一种前所未有的安全感。仿佛整个世界都在保护你，让你可以安心地闭上眼睛，慢慢沉入梦乡。</p>
<p><strong>适合场景：</strong>助眠、冥想、放松减压</p>
<p><strong>音频时长：</strong>60分钟</p>`,
    category: 'nature',
    author: '雨夜疗愈师',
    duration: '60分钟',
    image: 'https://readdy.ai/api/search-image?query=Rainy%20night%20view%20through%20window%2C%20raindrops%20on%20glass%2C%20cozy%20bedroom%20interior%2C%20soft%20warm%20light%20from%20inside%2C%20dark%20moody%20sky%2C%20minimalist%20cozy%20aesthetic%2C%20cream%20and%20deep%20blue%20gray%20tones&width=1200&height=800&seq=article-rain-01&orientation=landscape',
    date: '2026-07-25',
    tags: ['雨声', '雷声', '助眠', '白噪音', '大自然'],
    listenCount: 45200,
  },
  {
    id: 'art-003',
    title: '温柔理发店：剪刀声与头皮按摩',
    excerpt: '走进一家安静的理发店，感受剪刀清脆的咔嚓声与温柔的头皮按摩，让一天的疲惫烟消云散。',
    content: `<p>欢迎光临。请坐，放松。</p>
<p>这是一家藏在街角的小理发店。没有嘈杂的音乐，没有过多的人声，只有专业的工具和温柔的手法。当你坐下，理发师轻轻为你围上围布，一切就此开始。</p>
<p>首先是剪刀的声音。锋利的刀刃在发丝间穿梭，发出清脆而有节奏的咔嚓声。每一刀都精准而温柔，你甚至能感受到剪刀在耳边轻轻掠过的微风。这种声音有一种奇妙的魔力——它让你感到被照顾、被呵护。</p>
<p>然后是梳子梳理头发的沙沙声，温和而有规律。理发师的手指轻轻拨弄你的头发，偶尔触碰到头皮，带来一阵酥麻的舒适感。</p>
<p>接下来是头皮按摩。温热的手指在你的头皮上缓缓移动，带着恰到好处的力度。你能听到按摩时发出的细微摩擦声，伴随着自己的呼吸逐渐变得深沉而缓慢。</p>
<p>在这个小小的空间里，世界仿佛缩小到了这把椅子、这双手、这些声音。外界的烦恼被隔绝在门外，你只需要享受这一刻的宁静与放松。</p>
<p><strong>适合场景：</strong>压力释放、放松身心、睡前仪式</p>
<p><strong>音频时长：</strong>38分钟</p>`,
    category: 'roleplay',
    author: '街角理发店',
    duration: '38分钟',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20barbershop%20interior%20with%20warm%20lighting%2C%20vintage%20barber%20chair%2C%20scissors%20on%20wooden%20counter%2C%20clean%20white%20walls%20with%20warm%20accents%2C%20cozy%20professional%20atmosphere%2C%20cream%20and%20wood%20tones&width=1200&height=800&seq=article-barber-01&orientation=landscape',
    date: '2026-07-22',
    tags: ['理发店', '剪刀声', '头皮按摩', '角色扮演', '触发音'],
    listenCount: 31200,
  },
  {
    id: 'art-004',
    title: '木块敲击：不同木材的节奏之旅',
    excerpt: '探索竹木、松木、橡木等不同材质敲击出的独特音色，感受大自然馈赠的节奏之美。',
    content: `<p>木头，大自然最温暖的礼物之一。每一种木材都有它独特的灵魂，而敲击声就是它们的语言。</p>
<p>我们先从轻巧的竹木开始。竹片在指尖轻敲，发出清脆而空灵的声音，像是竹林中的雨滴，每一击都带着一种东方的禅意。</p>
<p>接下来是松木。松木质地较软，敲击声温和而深沉，带着一种厚实的包裹感。闭上眼睛，你仿佛能闻到松木特有的清香，感受到森林的气息。</p>
<p>橡木则完全不同——坚硬而致密，敲击声清脆有力，节奏感极强。每一次敲击都像是在打拍子，让人不由自主地跟着律动。</p>
<p>还有核桃木、樱桃木、枫木……每一种木材都是一个新的世界。它们的声音交织在一起，构成了一场属于木头的交响乐。</p>
<p><strong>适合场景：</strong>专注工作、创意激发、ASMR触发音收藏</p>
<p><strong>音频时长：</strong>32分钟</p>`,
    category: 'tapping',
    author: '木艺匠人',
    duration: '32分钟',
    image: 'https://readdy.ai/api/search-image?query=Various%20wooden%20blocks%20and%20objects%20arranged%20on%20minimalist%20surface%2C%20soft%20natural%20light%2C%20different%20wood%20textures%20and%20grains%2C%20warm%20earthy%20tones%2C%20artisan%20craftsmanship%20aesthetic%2C%20cream%20background&width=1200&height=800&seq=article-wood-01&orientation=landscape',
    date: '2026-07-20',
    tags: ['敲击', '木材', '触发音', '节奏', '质感'],
    listenCount: 19800,
  },
  {
    id: 'art-005',
    title: '酥脆炸鸡：令人满足的美食ASMR',
    excerpt: '金黄酥脆的炸鸡外皮，鲜嫩多汁的鸡肉，每一口都是听觉与味觉的双重盛宴。',
    content: `<p>小心，这个音频可能会让你感到饥饿。</p>
<p>刚出炉的炸鸡，外皮金黄酥脆，还冒着热气。当你用手指轻轻拿起一块，外皮发出细微的碎裂声——这是美食ASMR中最令人满足的瞬间之一。</p>
<p>第一口咬下去，清脆的咔嚓声在耳边炸开。酥脆的外皮在牙齿间碎裂，紧接着是鲜嫩多汁的鸡肉。咀嚼的声音丰富而有层次：外皮的酥脆、肉质的柔嫩、汁水在口腔中流动的细微声响。</p>
<p>每一口都是一种享受。你能听到手指与食物接触的声音，能听到咀嚼时不同质感的变化，甚至能听到满足的叹息声——这些声音组合在一起，创造了一种奇妙的满足感。</p>
<p>不仅仅是炸鸡，还有酥脆的薯条、冰涼的可乐气泡声……这是一场属于美食的ASMR派对。</p>
<p><strong>适合场景：</strong>美食享受、压力释放、感官刺激</p>
<p><strong>音频时长：</strong>25分钟</p>`,
    category: 'eating',
    author: '深夜食堂',
    duration: '25分钟',
    image: 'https://readdy.ai/api/search-image?query=Golden%20crispy%20fried%20chicken%20on%20minimalist%20ceramic%20plate%2C%20soft%20warm%20lighting%2C%20food%20photography%20style%2C%20steam%20rising%2C%20cozy%20dining%20atmosphere%2C%20cream%20and%20golden%20brown%20tones%2C%20shallow%20depth%20of%20field&width=1200&height=800&seq=article-chicken-01&orientation=landscape',
    date: '2026-07-18',
    tags: ['美食', '炸鸡', '咀嚼音', '酥脆', '治愈'],
    listenCount: 52300,
  },
  {
    id: 'art-006',
    title: '海浪与沙滩：太平洋岸边的午后',
    excerpt: '坐在细软的沙滩上，听海浪一波一波地涌来又退去，海鸥在远处鸣叫，享受最纯粹的自然白噪音。',
    content: `<p>这是一段来自太平洋岸边的录音。没有城市的喧嚣，没有人群的嘈杂，只有大海最真实的声音。</p>
<p>海浪是这段音频的主角。你能听到它们在远处酝酿，然后慢慢靠近，最后在沙滩上轻轻拍打，发出温柔的"哗——"声。随后海水缓缓退去，带走细沙，留下一片湿润的痕迹。这个循环一次又一次地重复，像是地球的呼吸。</p>
<p>偶尔会有较大的浪花涌来，声音更加澎湃有力，但很快又回归到温和的节奏。海鸥在远处盘旋，发出悠长的鸣叫，为这幅声音画卷增添了生动的点缀。</p>
<p>风从海面上吹来，带着咸咸的味道。你仿佛能感受到阳光洒在皮肤上的温暖，沙子从脚趾间流过的细腻触感。</p>
<p>在这样的声音中，思绪会自然地放空。不需要刻意去想什么，只需要让海浪带走一切烦恼。</p>
<p><strong>适合场景：</strong>深度放松、冥想、午休、白噪音背景</p>
<p><strong>音频时长：</strong>90分钟</p>`,
    category: 'nature',
    author: '海洋录音师',
    duration: '90分钟',
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20ocean%20beach%20with%20gentle%20waves%2C%20soft%20golden%20afternoon%20light%2C%20seagulls%20in%20distance%2C%20minimalist%20seascape%2C%20cream%20sand%20and%20soft%20blue%20gray%20water%2C%20calming%20atmospheric%20landscape&width=1200&height=800&seq=article-ocean-01&orientation=landscape',
    date: '2026-07-15',
    tags: ['海浪', '沙滩', '自然音', '白噪音', '深度放松'],
    listenCount: 67400,
  },
  {
    id: 'art-007',
    title: 'SPA会馆：精油推拿与颂钵疗愈',
    excerpt: '专业SPA体验，从精油推拿到颂钵共振，全方位的声音疗愈之旅。',
    content: `<p>走进这家静谧的SPA会馆，让声音带你开启一段疗愈之旅。</p>
<p>首先是精油的香气。按摩师将温热的精油倒在掌心，双手轻轻搓揉，发出细腻的摩擦声。当手掌触及你的背部时，你能听到精油在皮肤上滑过的柔滑声响——丝滑、温润，带着一种深层的舒适感。</p>
<p>推拿的手法时而轻柔时而有力。按压穴位时你能听到轻微的"咯吱"声，那是身体在释放紧张。揉捏肌肉时发出有节奏的声响，每一寸肌肤都在被唤醒。</p>
<p>然后是颂钵。金属钵体被轻轻敲击，发出悠长而空灵的共鸣声。那声音不是戛然而止的，而是慢慢扩散、慢慢消散，像是水面上荡漾的涟漪。颂钵的振动仿佛能穿透身体，直达内心深处。</p>
<p>偶尔还有风铃的清脆声响和水流的潺潺声，为整个空间增添了更多层次。</p>
<p><strong>适合场景：</strong>深度疗愈、身心放松、瑜伽冥想</p>
<p><strong>音频时长：</strong>55分钟</p>`,
    category: 'roleplay',
    author: '云端SPA',
    duration: '55分钟',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20spa%20room%20with%20soft%20candlelight%2C%20massage%20table%20with%20white%20towels%2C%20singing%20bowl%20on%20wooden%20shelf%2C%20aromatherapy%20bottles%2C%20minimalist%20zen%20aesthetic%2C%20cream%20and%20warm%20beige%20tones&width=1200&height=800&seq=article-spa-01&orientation=landscape',
    date: '2026-07-12',
    tags: ['SPA', '精油', '颂钵', '疗愈', '推拿'],
    listenCount: 24100,
  },
  {
    id: 'art-008',
    title: '键盘打字：复古打字机与机械键盘',
    excerpt: '从复古打字机的金属敲击到现代机械键盘的清脆反馈，不同键盘的节奏感带你进入心流状态。',
    content: `<p>键盘，是当代人最亲密的伙伴之一。每一种键盘都有它独特的声音个性。</p>
<p>我们从一台老式打字机开始。按下每一个字母都需要一定的力度，金属连杆在空中划过，最后"啪"的一声敲击在色带上。每打完一行，你需要手动推动滚筒——"咔哒"一声，清脆而满足。这种声音让你感受到文字的重量。</p>
<p>然后是青轴机械键盘。每一次按键都有明显的段落感和清脆的"咔嗒"声，节奏明快而有力。当打字速度加快时，连续的敲击声如同雨点般密集，让人不由自主地沉浸在打字的节奏中。</p>
<p>还有茶轴键盘——声音更温和一些，带着一种柔和的触感反馈。红轴则更加安静，只有轻微的摩擦声，适合喜欢低调的用户。</p>
<p>不同键盘的声音交织在一起，像是在演奏一场属于打字的音乐会。无论你偏好哪种声音，都能在这段音频中找到属于自己的节奏。</p>
<p><strong>适合场景：</strong>专注工作、写作灵感、学习陪伴</p>
<p><strong>音频时长：</strong>40分钟</p>`,
    category: 'tapping',
    author: '键盘收藏家',
    duration: '40分钟',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20typewriter%20next%20to%20modern%20mechanical%20keyboard%20on%20wooden%20desk%2C%20soft%20desk%20lamp%20lighting%2C%20minimalist%20workspace%2C%20warm%20cozy%20atmosphere%2C%20cream%20and%20wood%20tones%2C%20shallow%20depth%20of%20field&width=1200&height=800&seq=article-keyboard-01&orientation=landscape',
    date: '2026-07-10',
    tags: ['键盘', '打字', '触发音', '机械键盘', '专注'],
    listenCount: 35800,
  },
  {
    id: 'art-009',
    title: '手部视觉：缓慢手势与光线变化',
    excerpt: '通过舒缓的手部动作与柔和的光影变化，用视觉引导你进入深度放松状态。',
    content: `<p>有时候，最好的放松不需要任何声音——只需要静静地看着。</p>
<p>在这段视觉ASMR内容中，一双手在柔和的光线下缓缓移动。手指在空中画出优美的弧线，像是在指挥一首无声的乐曲。每一个动作都缓慢而精准，带着一种催眠般的节奏感。</p>
<p>光线随着手部的移动而变化。有时手掌遮住了光源，投下淡淡的阴影；有时光线从指缝间穿过，形成美丽的光斑。这些明暗变化创造出一种梦幻般的视觉效果。</p>
<p>手部的动作包括：手指的轻弹、手掌的翻转、手背的抚摸。每一个动作都重复多次，让你有足够的时间去感受其中的细微差别。偶尔手中会出现一些小道具——羽毛、丝巾、水晶——它们的质感和光影变化为画面增添了更多层次。</p>
<p>看着这双温柔的手，你的呼吸会不自觉地放慢，眼皮变得沉重。这是一种不需要语言的放松方式。</p>
<p><strong>适合场景：</strong>视觉放松、睡前观看、焦虑缓解</p>
<p><strong>音频时长：</strong>20分钟</p>`,
    category: 'visual',
    author: '视觉疗愈师',
    duration: '20分钟',
    image: 'https://readdy.ai/api/search-image?query=Gentle%20hands%20moving%20slowly%20in%20soft%20golden%20light%2C%20minimalist%20studio%20background%2C%20therapeutic%20hand%20gestures%2C%20calming%20visual%20triggers%2C%20cream%20and%20warm%20beige%20tones%2C%20soft%20focus%20dreamy%20aesthetic&width=1200&height=800&seq=article-hands-01&orientation=landscape',
    date: '2026-07-08',
    tags: ['视觉触发', '手部动作', '光线', '无声', '放松'],
    listenCount: 18300,
  },
  {
    id: 'art-010',
    title: '果冻Q弹：多彩果冻的咀嚼狂欢',
    excerpt: '各种口味的Q弹果冻，从吸吮到咀嚼，每一口都带来极致的听觉满足感。',
    content: `<p>准备好迎接一场Q弹的盛宴了吗？</p>
<p>我们准备了各式各样的果冻——草莓味的粉嫩、葡萄味的紫透、芒果味的金黄。每一个都在灯光下晶莹剔透，轻轻一晃就颤颤悠悠。</p>
<p>用小勺子轻轻舀起一块果冻，能听到勺子与果冻表面接触时的细微声响。送入口中，先用嘴唇轻轻吸住——"啵"的一声，果冻从勺子上滑入口中。</p>
<p>然后开始咀嚼。果冻在牙齿间弹跳，发出Q弹有嚼劲的声音。不同于酥脆的食物，果冻的声音更加柔韧、更加有弹性。每一次咀嚼都能感受到它在口腔中变换形状，那种满足感难以言喻。</p>
<p>不同口味的果冻有略微不同的质感——有些更软更嫩，有些更有弹性。你可以在音频中一一体验它们的区别。</p>
<p><strong>适合场景：</strong>美食享受、感官触发、放松娱乐</p>
<p><strong>音频时长：</strong>22分钟</p>`,
    category: 'eating',
    author: '甜品达人',
    duration: '22分钟',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20translucent%20jelly%20desserts%20in%20glass%20bowls%2C%20soft%20natural%20light%2C%20minimalist%20food%20photography%2C%20vibrant%20yet%20soft%20colors%2C%20cream%20background%2C%20playful%20elegant%20aesthetic&width=1200&height=800&seq=article-jelly-01&orientation=landscape',
    date: '2026-07-05',
    tags: ['美食', '果冻', '咀嚼音', 'Q弹', '治愈'],
    listenCount: 29700,
  },
  {
    id: 'art-011',
    title: '森林清晨：鸟鸣与溪流的交响',
    excerpt: '清晨第一缕阳光洒进森林，鸟儿开始歌唱，溪水潺潺流淌，唤醒你充满活力的一天。',
    content: `<p>清晨五点，森林正在醒来。</p>
<p>第一声鸟鸣划破了黎明的寂静。起初是零星的几声，然后越来越多的鸟儿加入了合唱。画眉的婉转、布谷的悠扬、山雀的清脆——每一种鸟鸣都有独特的音色和节奏，它们交织在一起，构成了森林最动听的晨曲。</p>
<p>溪水从未停止流淌。它从山间蜿蜒而下，在岩石间跳跃，发出潺潺的水声。水流撞击石头时溅起细小的水花，声音清脆悦耳。偶尔有一片树叶落入水中，轻轻漂浮，顺流而下。</p>
<p>微风穿过树梢，带动树叶沙沙作响。阳光透过茂密的树冠，在地面上投下斑驳的光影。空气中弥漫着泥土和露水的清新气息。</p>
<p>这是一个全新的开始。在这样的声音中醒来，你会感到充满活力和希望。森林告诉你：每一天都是美好的。</p>
<p><strong>适合场景：</strong>晨间唤醒、自然白噪音、冥想正念</p>
<p><strong>音频时长：</strong>50分钟</p>`,
    category: 'nature',
    author: '森林录音师',
    duration: '50分钟',
    image: 'https://readdy.ai/api/search-image?query=Morning%20sunlight%20streaming%20through%20forest%20trees%2C%20misty%20atmosphere%2C%20small%20stream%20flowing%2C%20lush%20green%20foliage%2C%20peaceful%20natural%20landscape%2C%20soft%20golden%20light%2C%20cream%20and%20green%20tones%2C%20ethereal%20quality&width=1200&height=800&seq=article-forest-01&orientation=landscape',
    date: '2026-07-02',
    tags: ['森林', '鸟鸣', '溪流', '清晨', '大自然'],
    listenCount: 38900,
  },
  {
    id: 'art-012',
    title: '耳畔低语：晚安，做个好梦',
    excerpt: '温柔的晚安耳语，用最亲密的距离说最暖心的话，伴你缓缓进入甜蜜梦乡。',
    content: `<p>嗨，该睡觉了。</p>
<p>让我靠近一点，在你的耳边轻轻说话。不会说太多，就几句晚安的话。</p>
<p>"今天辛苦你了。无论今天发生了什么，明天都是崭新的一天。现在，把所有烦恼都放下，只专注于我的声音……"</p>
<p>声音很轻很轻，像是羽毛拂过耳畔。每一个字都带着温柔的气息，你能感受到说话时的气流轻轻触碰你的耳朵。这种近距离的耳语创造了一种奇妙的亲密感和安全感，仿佛有人就在你身边守护着你。</p>
<p>"深呼吸……吸气……呼气……对，就是这样。感受你的身体正在慢慢放松。从脚趾开始，到小腿、大腿、腹部、胸部、肩膀、脖子……每一个部位都在变得柔软。"</p>
<p>偶尔会有轻微的嘴唇音，或是吞咽的声音——这些细微的声响都成为了ASMR触发的一部分。</p>
<p>"晚安，做个好梦。明天醒来，一切都会更好的。"</p>
<p><strong>适合场景：</strong>睡前放松、缓解失眠、焦虑安抚</p>
<p><strong>音频时长：</strong>30分钟</p>`,
    category: 'whisper',
    author: '晚安 whisperer',
    duration: '30分钟',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20bedroom%20at%20night%20with%20soft%20warm%20bedside%20lamp%2C%20fluffy%20pillows%20and%20blankets%2C%20minimalist%20interior%2C%20calming%20atmosphere%2C%20cream%20and%20soft%20beige%20tones%2C%20intimate%20and%20peaceful%20mood&width=1200&height=800&seq=article-goodnight-01&orientation=landscape',
    date: '2026-06-30',
    tags: ['耳语', '晚安', '助眠', '亲密', '温柔'],
    listenCount: 56100,
  },
];

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getArticleById = (id: string) => {
  return articles.find((a) => a.id === id);
};

export const getPopularArticles = (limit: number = 4) => {
  return [...articles].sort((a, b) => b.listenCount - a.listenCount).slice(0, limit);
};

export const getLatestArticles = (limit: number = 4) => {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, limit);
};